<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/tree_sub.jpg" />
      <h1 class="">組織図</h1>
    </div>
    <div>
      <div id="Organization">
        <div class="tree-search mt-5">
          会員番号
          <input v-model="treeSearchNo" type="number" />
          <button
            type="button"
            @click="treeSearch"
            name="input btn"
            align="middle"
            class="ml-3"
          >
            Go
          </button>
        </div>
            <select v-model="year" class="k4 w-auto px-3 mb-2">
              <option
                v-for="(y, index) in years"
                :key="y"
                :value="y"
                :selected="index === 0"
              >
                {{ y }}
              </option>
            </select>
            <span class="mr-3">年</span>
            <select v-model="month" class="w-auto px-3 mb-2">
              <option
                v-for="(m, index) in months"
                :key="m"
                :value="m"
                :selected="index === 0"
              >
                {{ m }}
              </option>
            </select>
            <span class="mr-3">月</span>
          <button
            type="button"
            @click="myResult"
            name="input btn"
            align="middle"
            class="ml-3"
          >
            Go
          </button>
        <div class="tree_info">
          <label class="label_yellow">前・当年度の購入なしの方</label><br class="only_sp">
          <label class="label_orange">当年度の購入なしの方</label><br class="only_sp">
          <label class="label_green">入会後30日以内の方</label><br class="only_sp">
          <label class="label_star">ショッピング会員</label>
        </div>
        <div class="tree_group w-100" ref="tree" id="tree">
          <ul>
            <li v-for="item in tree" :key="item.Member">
              <treeItem :tree="item" :fullOpen="fullOpentogle"></treeItem>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Request from "@/modules/Request";
import treeItem from "./components/treeItem";
import Message from "@/modules/Message";
let request = new Request();

export default {
  components: {
    treeItem,
  },
  data() {
    return {
      treeContainer: "",
      tree: [],
      treeSearchNo: "",
      fullOpentogle: true,
      years: [],
      months: [],
      year: "",
      month: "",
      targetMonth: null,
      isSet : true,
    };
  },
  watch: {
    year: function (val) {
      this.changeYear(val);
    },
    month: function(val){
      var month;
      var year;
        year = this.year
        month = val
      this.targetMonth = year+'/'+month.toString().padStart(2, '0');
      console.log("taegetMonth:"+this.targetMonth)
    }
  },
  mounted() {
    console.log('mounted')
    window.scroll(0, 0);
    const now = new Date();
    console.log('setitem')
    this.years[0] = now.getFullYear();
    this.years[1] = now.getFullYear()-1;
    this.year = now.getFullYear();
    this.month = now.getMonth()+1;
    this.targetMonth = this.year+'/'+this.month.toString().padStart(2, '0');
    this.myResult();
  },
  methods: {
    treeSearch() {
      let mes;
      this.treeSearchNo == ""
        ? (mes = "会員番号が未入力です。")
        : (mes = "会員番号が一致しません。");
      if (!document.getElementById(this.treeSearchNo)) {
        Message.error().fire({
          title: mes,
        });
        return;
      }

      this.fullOpentogle
        ? (this.fullOpentogle = false)
        : (this.fullOpentogle = true);
      this.$nextTick(function () {
        let target = document.getElementById(this.treeSearchNo);
        let target2 = document.getElementById("tree");
        var rect = target.getBoundingClientRect();
        var rect2 = target2.getBoundingClientRect();
        var elemtop = rect.top - rect2.top;
        target2.scrollTop += elemtop;
        this.$store.state.treeIsClickMember = this.treeSearchNo;
      });
      
    },
    changeYear(year) {
      if (!year) {
        // 年が無効なら先頭をデフォルト選択する
        year = this.years[0];
      }
      this.year = year;
      const now = new Date();
      const nowMonth = now.getMonth()+1;

      // 該当年のオブジェクトを取得し、月のリストを生成する
      this.months = [];
      if(this.year === now.getFullYear()){
          for (var i = 0; i<= now.getMonth(); i++ ){
            this.months[i] = i+1;
          }
      }else{
        var j = 0;
        for(i = nowMonth ; i <= 12; i++){
          this.months[j] = i;
          j++;
        }
      }
      // 月のリストを再生成しているため、月は先頭を選択
      if(this.isSet){
        this.isSet  = false
        return
      }
       this.month = this.months[0];
       this.targetMonth = this.year+'/'+this.month.toString().padStart(2, '0');


      
    },
    myResult() {
      this.treeSearchNo = ''
      this.getResult('');
    },
    getResult(memberNo) {
      console.log('getResult')
      console.log('this.targetMonth:'+this.targetMonth)
      let postParams = [memberNo,this.targetMonth];
      let requestParams = request.createParams(
        "webMdlResult",
        "getResults",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.tree[0] = data.TVContents;
          this.treeContainer = data.TreeviewContainer;
        });
    },
  },
};
</script>

<style scoped>
#tree {
  overflow-y: auto;
  height: 800px;
  margin-top: 1em;
}
dl.rank {
  display: flex;
  display: -ms-flexbox;
  align-items: center;
}
dl.rank dt,
dl.rank dd {
  padding: 10px 15px;
  border: 1px solid #ccc;
}
dl.rank dt {
  background: #e4e4e4;
}
dl.rank dd {
  font-weight: bold;
}
dl.rank {
  width: max-content;
}
/* タブ */
.tab-wrap {
  display: flex;
  flex-wrap: wrap;
}
.tab-label {
  background: #fff;
  margin-right: 5px;
  margin-bottom: -1px;
  padding: 10px 15px;
  order: -1;
  border: 1px solid #ccc;
}
.tab-label:hover {
  cursor: pointer;
  background: #fafafa;
}
.tab-content {
  width: 100%;
  display: none;
  padding: 20px;
  border-top: 3px solid #e4e4e4;
  box-shadow: 1px 1px 5px #e4e4e4;
}
/* アクティブなタブ */
.tab-switch:checked + .tab-label {
  background: #e4e4e4;
}
.tab-switch:checked + .tab-label + .tab-content {
  display: block;
}
/* ラジオボタン非表示 */
.tab-switch {
  display: none;
}

@media screen and (min-width: 1px) and (max-width: 991px) {
  dl.rank {
    flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    width: 100%;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  dl.rank dt {
    width: 190px;
    border-bottom: 1px solid #ccc;
  }
  dl.rank dd {
    width: calc(100% - 190px);
  }
  dl.rank dt,
  dl.rank dd {
    margin-bottom: 3px;
  }
  .tab-label {
    width: 47%;
    margin-left: 5px;
    margin-bottom: 5px;
  }
  .tab-wrap {
    justify-content: center;
  }
  .tab-content {
    border-top: none;
    margin-top: 1em;
  }
  .tab-content.tab-tree {
    padding: 20px 5px;
  }
  #tree {
    height: 600px;
  }
}
@media screen and (min-width: 1px) and (max-width: 498px) {
  .tree-search {
    text-align: center;
  }
  .tree-search button {
    margin-top: 10px;
  }
}
</style>